module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/152-kyrgyzstan-fb5f00ff7ef860d263e64e3706931536.svg";